import {uiMsg} from '../utils/Languages';
import {observable, computed, autorun, map} from 'mobx';


// Simple record to hold the location type
class LocationType {
  @observable id = null;
  @observable name = null;
  @observable description = null;

  // Get typename from type-id :
  // This method is duplicate from the Location object, and user
  // the same translations:
  @computed get typeName() {
    if(!this.id) return uiMsg('LOC_ROOM','Room');
    return  {'B'  : uiMsg('LOC_BUILDING','Building'),
             'S'  : uiMsg('LOC_SECTION','Section'),
             'E'  : uiMsg('LOC_ENTRANCE','Entrance'),
             'A'  : uiMsg('LOC_AREA','Area')    ,
             'R'  : uiMsg('LOC_ROOM','Room')    ,
             'F'  : uiMsg('LOC_FLOOR','Floor')}[this.id];
  }


}

// For now this is just a blind copy of the rows from the database.
function createLocationTypeFromDBRow(row) {
  var lt = new LocationType();
  lt.id=row.id;
  lt.name = row.name;
  lt.description = row.description;
  return lt;
}

// Utility method available from Class (function)
LocationType.createFromDBRow=createLocationTypeFromDBRow;

export default LocationType;



/** WEBPACK FOOTER **
 ** ./src/DataModel/LocationType.js
 **/